import React from "react";
import banner from "./assets/Banner.webp";

import { TbSection } from "react-icons/tb";
import HeroSection from "./Components/HeroSection";
import SlideUpCards from "./Components/InternalPages/SlideUpCards";
import ChoosePackky from "./Components/InternalPages/ChoosePackky";
import PackkyWorks from "./Components/PackkyWorks";
import FourCards from "./Components/InternalPages/FourCards";
import OurService from "./Components/InternalPages/OurService";
import CodeStrength from "./Components/InternalPages/CodeStrength";
import LatestBlogs from "./Components/InternalPages/LatestBlogs";

function Home() {
  return (
    <>
      <HeroSection />
      <SlideUpCards />
      <ChoosePackky />
      <PackkyWorks />
      <CodeStrength />
      <section className="container-fluid55 position-relative px-lg-0 mt-0">
        <img
          src={banner}
          alt="Background"
          className=" w-100 h-100 img-fluid2"
          style={{
            objectFit: "cover",
            minHeight: "320px",
            maxHeight: "80vh",
            filter: "brightness(100%)",
          }}
        />

        <div className="position-absolute top-50 start-50 translate-middle text-center w-100 text-white px-3">
          <h1 className="fw-bold mt-4 fs-3 fs-md-2 fs-lg-1">
            Stay in the Loop with Live Updates
          </h1>

          <p className="fw-normal fs-5 fs-md-5 fs-lg-4 mt-4 px-4 custom-paragraph">
            With real-time tracking, you can monitor every delivery’s progress
            in just a glance. Customers receive instant updates, ensuring they
            stay informed and excited for their order’s arrival.
          </p>
        </div>
      </section>
      <FourCards />
      <OurService />
      <LatestBlogs />
    </>
  );
}
export default Home;
